export const CREATE_CAMPAIGN_SIDEBAR_CLOSE = 'CREATE_CAMPAIGN_SIDEBAR_CLOSE';
export const CREATE_CAMPAIGN_SIDEBAR_CHOOSE_CAMPAIGN = 'CREATE_CAMPAIGN_SIDEBAR_CHOOSE_CAMPAIGN';
export const CREATE_CAMPAIGN_SIDEBAR_LOADING_DATA = 'CREATE_CAMPAIGN_SIDEBAR_LOADING_DATA';
export const CREATE_CAMPAIGN_SIDEBAR_SWAG_SELECT = 'CREATE_CAMPAIGN_SIDEBAR_SWAG_SELECT';
export const CREATE_CAMPAIGN_SIDEBAR_SWAG_DIGITAL_CODES = 'CREATE_CAMPAIGN_SIDEBAR_SWAG_DIGITAL_CODES';
export const CREATE_CAMPAIGN_SIDEBAR_SWAG_PHYSICAL_CODES = 'CREATE_CAMPAIGN_SIDEBAR_SWAG_PHYSICAL_CODES';
